import React from 'react';
import Tooltip from '@mui/material/Tooltip';

interface Props {
  text: string;
  truncateNumber?: number;
}

const ConditionalTruncatedTextWithTooltip: React.FC<Props> = ({
  text,
  truncateNumber = 100,
}) => {
  if (!text) {
    return null;
  }

  if (text.length <= truncateNumber) {
    return <span>{text}</span>;
  } else {
    const previewText = text.substring(0, truncateNumber) + '...';

    return (
      <Tooltip title={text} arrow>
        <span>{previewText}</span>
      </Tooltip>
    );
  }
};

export default ConditionalTruncatedTextWithTooltip;
